import { useParams } from "react-router-dom";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { IndustryCta } from "@/components/industry/IndustryCta";
import { IndustryHero } from "@/components/industry/IndustryHero";
import { IndustryIntro } from "@/components/industry/IndustryIntro";
import { IndustryJourney } from "@/components/industry/IndustryJourney";
import { IndustryPaths } from "@/components/industry/IndustryPaths";
import { IndustryProgrammes } from "@/components/industry/IndustryProgrammes";
import NotFound from "@/pages/NotFound";
import { getIndustry, industryPath } from "@/data/industries";
import { getIndustryContent } from "@/data/industryContent";
import { Seo } from "@/lib/seo/Seo";
import { breadcrumbSchema } from "@/lib/seo/schema";

/**
 * Industry landing page (/industries/:industryId).
 * Copy is in src/data/industryContent.js.
 * SEO meta, theme and the hero cut-out live in src/data/industries.js.
 */
export default function Industry() {
  const { industryId } = useParams();
  const industry = getIndustry(industryId);
  const content = industry ? getIndustryContent(industry.id) : null;

  if (!industry || !content) return <NotFound />;

  const jsonLd = [
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: industry.name, path: industryPath(industry.id) },
    ]),
  ];

  return (
    <SiteLayout>
      <Seo
        title={industry.metaTitle}
        description={industry.metaDescription}
        path={industryPath(industry.id)}
        image={industry.heroImage}
        jsonLd={jsonLd}
      />
      <div data-testid={`industry-page-${industry.id}`}>
        <IndustryHero industry={industry} content={content} />
        <IndustryIntro intro={content.intro} />
        <IndustryPaths paths={content.paths} />
        <IndustryJourney journey={content.journey} />
        <IndustryProgrammes programmes={content.programmes} />
        <IndustryCta cta={content.cta} />
      </div>
    </SiteLayout>
  );
}
